/**
 * Registers `public/sw.js` in production only — never in dev, where a
 * cached request would fight Vite's own dev server and HMR instead of the
 * built, nginx-served assets it's meant for. Guarded against browsers with
 * no `navigator.serviceWorker` (older Safari, some in-app browsers), so
 * this is always safe to call unconditionally from main.tsx — the same
 * "no-op unless supported/configured" shape as initSentry/initAnalytics.
 *
 * Registered `{ type: 'module' }` so sw.js can `export` its bypass function
 * for direct testing (see tests/serviceWorker.test.ts) rather than needing
 * a separate copy of that logic.
 */
export function registerServiceWorker(): void {
  if (import.meta.env.DEV) return;
  if (!('serviceWorker' in navigator)) return;

  navigator.serviceWorker.register('/sw.js', { type: 'module' }).catch(() => {
    // The app works fully without the worker — installing it is a bonus,
    // not a dependency, so a failed registration (offline first load, a
    // browser quirk) shouldn't be treated as an app-breaking error.
  });
}
